import { RoutePropsWithPathResolver } from 'types'
import authRoutes from './features/auth/routes'
import mapRoutes from './features/map/routes'
import spaceOverviewRoutes from './features/spaces/routes'
import boothRoutes from './features/booth/routes'
import showRoutes from './features/shows/routes'
import generalSettingsRoutes from './features/generalsettings/routes'
import presentationRoutes from './features/presentation/routes'
import cinemaRoutes from './features/cinema/routes'
import speakerRoutes from './features/speakers/routes'
import networkingRoutes from './features/networking/routes'
import posterRoutes from './features/posters/routes'
import eventAdminsRoutes from './features/admins/routes'
import navigationRoutes from './features/navigation/routes'
import meetingRoutes from './features/meetings/routes'
import attendeeRoutes from './features/attendees/routes'
import groupSessionRoutes from './features/groupsessions/routes'
import jobRoutes from './features/jobs/routes'
import chatRouletteRoutes from './features/chat_roulette/routes'
import organizationRoutes from './features/organization/routes'
import dashboardRoutes from './features/dashboard/routes'
import gdprRoutes from './features/gdpr/routes'
import embeddedRoutes from './features/embedded_space/routes'

const routes = {
    ...authRoutes,
    ...mapRoutes,
    ...spaceOverviewRoutes,
    ...boothRoutes,
    ...showRoutes,
    ...generalSettingsRoutes,
    ...presentationRoutes,
    ...cinemaRoutes,
    ...speakerRoutes,
    ...networkingRoutes,
    ...posterRoutes,
    ...eventAdminsRoutes,
    ...navigationRoutes,
    ...meetingRoutes,
    ...attendeeRoutes,
    ...groupSessionRoutes,
    ...jobRoutes,
    ...chatRouletteRoutes,
    ...organizationRoutes,
    ...dashboardRoutes,
    ...gdprRoutes,
    ...embeddedRoutes,
}

export const allRoutes = Object.values(routes) as RoutePropsWithPathResolver<any>[]
export const eventRouteList = allRoutes.filter(({ isEventRoute }) => isEventRoute)
export const noEventRouteList = allRoutes.filter(({ isEventRoute }) => !isEventRoute)
export default routes
